import { NgModule } from '@angular/core';
import { InfoAlertComponent } from './info-alert.component';

@NgModule({
	declarations: [],
	imports: [InfoAlertComponent],
	exports: [InfoAlertComponent],
})
export class InfoAlertModule {}
